import '../styles/home.css';

const Home = () => {
    return (
        <div className="home">
            <h1 className="home__title">Michael DaRocha</h1>
            <h2 className='home__subtitle'>Associate Software Engineer @ Capital One </h2>
        </div>
    );
};

export default Home;